// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"138":"fd509146","352":"1d9765b2"}[chunkId] + ".chunk.css";
};